import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ErrorLoadingAsync = ({
  retry
}) => /*#__PURE__*/_jsx(ErrorMessage, {
  type: "badRequest",
  children: /*#__PURE__*/_jsx(Link, {
    onClick: () => retry(),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "collaborationSidebar.panelLoad.error"
    })
  })
});